import { render, staticRenderFns } from "./ContabilitaDocumentoDestinazioneModalComponent.vue?vue&type=template&id=6e24421f&scoped=true"
import script from "./ContabilitaDocumentoDestinazioneModalComponent.vue?vue&type=script&lang=js"
export * from "./ContabilitaDocumentoDestinazioneModalComponent.vue?vue&type=script&lang=js"
import style0 from "./ContabilitaDocumentoDestinazioneModalComponent.vue?vue&type=style&index=0&id=6e24421f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e24421f",
  null
  
)

export default component.exports